module.exports = __webpack_public_path__ + "img/墨旱莲.5b516b56.jpg";